import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useIsTruncated } from 'hooks/useIsTruncated';

const EllipsisTitle = ({ text }: { text: string }) => {
  const { ref, isTruncated } = useIsTruncated([text]);
  const tooltipProps = isTruncated ? { title: text, disableHoverListener: false } : { title: '', disableHoverListener: true };

  return (
    <Tooltip enterDelay={450} {...tooltipProps}>
      <Typography ref={ref} noWrap>
        {text}
      </Typography>
    </Tooltip>
  );
};

export default EllipsisTitle;
